import API from '../api'
import getUrl from './paths'
import { enquiryStatus as enquiryStatusC } from '@constants'
import convertPagableData from '../convertPagableData'

export const getAllEnquiries = (enquiryStatus = enquiryStatusC.created, page = 0, enquiryFilters = null, userId = null, organisationId = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getEnquiries, { enquiryStatus, page, userId, organisationId, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

// Put an enquiry on the order book — GET /enquiry/addInOrderBook?enquiryId=<id>.
export const addInOrderBook = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.addInOrderBook, { enquiryId })
			.then((response) => resolve(response.data))
			.catch((err) => reject(err))
	})

export const getBuyerEnquiries = (page = 0, enquiryFilters = null, userId = null, organisationId = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getBuyerEnquiries, { page, userId, organisationId, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getSupplierEnquiries = (page = 0, enquiryFilters = null, userId = null, organisationId = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getSupplierEnquiries, { page, userId, organisationId, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getEnquiryById = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getEnquiryById, { enquiryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getPreviewPoChecks = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getPreviewPoChecks, { enquiryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getAdminEnquiries = (enquiryStatus = [enquiryStatusC.created], commodityFilter, page = 0, enquiryFilters = null) =>
	new Promise((resolve, reject) => {
		const status = Array.isArray(enquiryStatus) ? enquiryStatus.join(',') : enquiryStatus
		API.get(getUrl.getAdminEnquiries, { enquiryStatus: status, commodityFilter, page, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getAdminAssignedEnquiries = (
	enquiryStatus = enquiryStatusC.unverified,
	employeeId,
	commodityFilter,
	page = 0,
	enquiryFilters = null,
	hasQuotesFilter = null
) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAdminAssignedEnquiries, { enquiryStatus, page, employeeId, commodityFilter, hasQuotesFilter, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getEnquirySummaryStatus = (params = {}) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getEnquirySummaryStatus, { ...params })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((err) => reject(err))
	})

export const getAllProductPhotosBuyer = (orderId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllProductPhotosBuyer, { orderId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getScrapRequirement = () =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getScrapRequirement)
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getScrapSupplierQuotes = (city) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getScrapSupplierQuotes, { city })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getUserAddressesApi = (userId = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getUserAddresses, { userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getScrapSupplierQuotesV2 = (city) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getScrapSupplierQuotesV2, { city })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getExpectedTransitTime = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getExpectedTransitTime, { enquiryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getUnassignedEnquiries = (page = 0, size = 10, commodityFilter, enquiryFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getUnassignedEnquiries, { page, size, commodityFilter, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAssignedEnquiriesForSupplyAdmin = (active, page = 0, size = 10, commodityFilter, enquiryFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAssignedEnquiriesForSupplyAdmin, { active, page, size, commodityFilter, ...enquiryFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getSupplierQuoteSummary = (enquiryId, supplierQuoteId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getSupplierQuoteSummary, { enquiryId, supplierQuoteId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getEnquiryChecks = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getEnquiryChecks, { enquiryId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((err) => reject(err))
	})

export const getEnquiriesByOrderGiven = (userId, page = 0, size = 10) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getEnquiriesByOrderGiven, { userId, page, size })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})
